{
  "commonHeader": {
    "toggleSidebar": "Zijbalk in- of uitschakelen",
    "cartLoading": "Winkelwagen wordt geladen",
    "cart": "Winkelwagen",
    "aicForAdmin": {
      "ariaLabel": "AI voor beheerders"
    },
    "usersResults": "Gebruikers, {0} resultaten",
    "settingsResults": "Instellingen, {0} resultaten",
    "navigationResults": "Navigatie, {0} resultaten",
    "learnMoreAbout": "Meer informatie over {0}",
    "close": "Sluiten",
    "products": "Producten",
    "moreActions": "Meer acties",
    "search": "Zoeken",
    "searchPlaceholderAll": "Zoeken naar gebruikers, accountinstellingen of navigatie",
    "searchPlaceholderUsers": "Zoeken naar gebruikers of navigatie",
    "searchPlaceholderSettings": "Zoeken naar accountinstellingen of navigatie",
    "searchPlaceholderNav": "Zoeken in navigatie"
  },
  "footerCopyright": {
    "language": "Taal {0}"
  },
  "adminMenu": {
    "adminMenu": {
      "ariaLabel": "Beheermenu"
    }
  },
  "shared": {
    "close": "Sluiten",
    "sideMenu": {
      "personalAria": "Persoonlijk menu",
      "adminAria": "Beheermenu",
      "mainNav": "Hoofdnavigatie",
      "submenu": "Submenu",
      "pinnedSection": "{0} vastgemaakt",
      "sideMenuAria": "Zijmenu",
      "pinItem": "{0} vastmaken",
      "unpinItem": "{0} losmaken",
      "reorderGrabbed": "{0} opnieuw ordenen, vastgepakt. Gebruik de pijltoetsen omhoog en omlaag om te verplaatsen, spatie of Enter om neer te zetten, Escape om te annuleren.",
      "reorderIdle": "{0} opnieuw ordenen. Druk op spatie of Enter om vast te pakken.",
      "hintHandlePin": "Druk op Tab om de sleepgreep en de vastmaakknop te openen",
      "hintHandle": "Druk op Tab om de sleepgreep te openen",
      "hintPin": "Druk op Tab om de vastmaakknop te openen",
      "upgradeToPro": "Upgraden naar Pro"
    },
    "item": "Item"
  },
  "coachMark": {
    "coachMark": {
      "tryNewExperienceAria": "Nieuwe ervaring uitproberen"
    }
  },
  "aicGuide": {
    "common": {
      "close": "Sluiten"
    }
  },
  "divisionTips": {
    "coachMark": {
      "dvsTipsTitle": "Divisies zijn nu beschikbaar"
    }
  },
  "externalAccountTips": {
    "coachMark": {
      "extAccountTipsTitle": "Externe accounts beheren"
    }
  },
  "zccRenameTips": {
    "coachMark": {
      "tipsTitle": "Adresboek wordt Klantenlijst"
    }
  },
  "feedback": {
    "itemLableForProductArea": "Productgebied",
    "itemLableForFeedback": "Feedback"
  }
}
